import * as Sentry from '@sentry/react';
import { Navigate, useParams } from 'react-router-dom';

import { FeeDetailLayout } from '../components/organisms/layouts/feeDetail/FeeDetailLayout';

const FeesDetails = () => {
  const { feeId } = useParams();
  if (!feeId) {
    return <Navigate to="/student-fees" />;
  }
  return (
    <Sentry.ErrorBoundary fallback={<p>There was an error loading this fee</p>}>
      <FeeDetailLayout feeId={feeId} />
    </Sentry.ErrorBoundary>
  );
};

export { FeesDetails };
